import { NarrativesType } from 'app/modules/narratives/models';
import { useSelector } from 'react-redux';
import {
  selectHasReadAlertsPermission,
  selectHasReadCasesPermissions,
} from 'app/modules/session/selectors';
import { useQuery } from '@tanstack/react-query';
import { NARRATIVE_QUERY_KEYS } from 'app/modules/narratives/queries/keys';
import { post } from 'app/shared/utils/fetchr';
import { ListNarrativesResponse } from 'app/modules/narratives/responses';
import { ListNarrativesPayload } from 'app/modules/narratives/requests';

export const useGetNarratives = (id: number, type: NarrativesType) => {
  const hasReadAlertsPermission = useSelector(selectHasReadAlertsPermission);
  const hasReadCasesPermission = useSelector(selectHasReadCasesPermissions);
  const hasPermission =
    type === NarrativesType.ALERTS
      ? hasReadAlertsPermission
      : hasReadCasesPermission;

  const payload: ListNarrativesPayload = { article_id: id };

  return useQuery({
    enabled: hasPermission,
    queryKey: NARRATIVE_QUERY_KEYS.getNarratives(payload),
    queryFn: () => post<ListNarrativesResponse>(`/narratives/list`, payload),
  });
};
